module.exports = __webpack_public_path__ + "static/media/search_money.6f0a3036.svg";